import Swal from "sweetalert2";

export const Confirm = (
  title = "حذف محصول",
  text = "آیا از حذف محصول اطمینان دارید ؟",
  confirmButtonText = "تایید" ,
  cancelButtonText = "لغو",
  icon = "error"
) => {
  return Swal.fire({
    title,
    text,
    icon,
    showCancelButton: true,
    confirmButtonText,
    cancelButtonText,
   
  });
};

export const Alert = (
  title = "خطا",
  text = "خطایی رخ داده است",
  icon = "error",
  confirmButtonText = "تایید"
) => {
  return Swal.fire({
    title,
    text,
    icon ,
    confirmButtonText,
  
  });
};